@defer (on viewport) {
  @if (!hideText()) {
    <footer class="footer">
      <div class="container providers-container">
        <div class="title-container">
          <div class="title__line"></div>
          <div class="title__text text-gradient">{{ 't.payment-methods' | translate }}</div>
          <div class="title__line"></div>
        </div>
        <app-accordion-button [isFooter]="true" class="payments">
          @if (paymentMode.isModeCrypto) {
            <ng-container *ngTemplateOutlet="crypto"></ng-container>
          }
          @if (!paymentMode.isModeCrypto) {
            <ng-container *ngTemplateOutlet="fiat"></ng-container>
          }
        </app-accordion-button>
        <div class="providers-container">
          <ng-template #crypto>
            @if (paymentList$ | async; as paymentList) {
              <div class="providers --center --clickable --crypto-grid" [routerLink]="'/account/deposit'">
                @for (payment of paymentList; track $index) {
                  @if (payment?.IsCrypto) {
                    <img
                      DeleteNotFound
                      ClassLoaded
                      class="providers__item --payment"
                      ImgDimension
                      height="40"
                      width="60"
                      [attr.data-src]="'/assets/svg/payments/coinspaid/white/' + payment?.slug + '.svg'"
                      [alt]="seo.metaTitle"
                    />
                  }
                }
              </div>
            }
            @if (paymentList$ | async; as paymentList) {
              <div class="providers --center --clickable" [routerLink]="'/account/deposit'">
                @for (payment of paymentList; track $index) {
                  @if (!payment?.IsCrypto) {
                    <img
                      DeleteNotFound
                      ClassLoaded
                      class="providers__item {{ payment?.slug }}"
                      ImgDimension
                      height="40"
                      width="60"
                      [attr.data-src]="
                        !payment?.footerImg
                          ? 'https://cdn2.softswiss.net/logos/payments/white/' + payment?.slug + '.svg'
                          : payment.footerImg
                      "
                      [alt]="seo.metaTitle"
                    />
                  }
                }
              </div>
            }
          </ng-template>
          <ng-template #fiat>
            @if (paymentList$ | async; as paymentList) {
              <div class="providers --center --clickable" [routerLink]="'/account/deposit'">
                @for (payment of paymentList; track $index) {
                  @if (!payment?.IsCrypto) {
                    <img
                      DeleteNotFound
                      ClassLoaded
                      class="providers__item {{ payment?.slug }}"
                      ImgDimension
                      height="26"
                      width="60"
                      [attr.data-src]="
                        !payment?.footerImg
                          ? 'https://cdn2.softswiss.net/logos/payments/white/' + payment?.slug + '.svg'
                          : payment.footerImg
                      "
                      [alt]="seo.metaTitle"
                    />
                  }
                }
              </div>
            }
            @if (paymentList$ | async; as paymentList) {
              <div class="providers --center --clickable --crypto-grid" [routerLink]="'/account/deposit'">
                @for (payment of paymentList; track $index) {
                  @if (payment?.IsCrypto) {
                    <img
                      DeleteNotFound
                      ClassLoaded
                      class="providers__item --payment"
                      ImgDimension
                      height="26"
                      width="60"
                      [attr.data-src]="'/assets/svg/payments/coinspaid/white/' + payment?.slug + '.svg'"
                      [alt]="seo.metaTitle"
                    />
                  }
                }
              </div>
            }
          </ng-template>
          <div class="title-container">
            <div class="title__line"></div>
            <div class="title__text text-gradient">{{ 't.providers' | translate }}</div>
            <div class="title__line"></div>
          </div>
          <app-accordion-button [isFooter]="true">
            @if (providerList$ | async; as providerList) {
              <div class="providers --center clickable">
                @for (provider of providerList; track $index) {
                  <a class="providers__item" [routerLink]="'/games/' + provider?.alias">
                    <img
                      DeleteNotFound
                      ClassLoaded
                      ImgDimension
                      height="26"
                      width="60"
                      class="{{provider?.alias}}"
                      [attr.data-src]="provider?.imgAlias"
                      [alt]="seo.metaTitle"
                    />
                  </a>
                }
              </div>
            }
          </app-accordion-button>
        </div>
        <div class="title-container">
          <div class="title__line"></div>
          <div class="title__text text-gradient">{{ 't.social-media' | translate }}</div>
          <div class="title__line"></div>
        </div>
        @if (social$ | async; as social) {
          <div class="providers --center clickable">
            <div class="social__actions">
              @if (social[0]?.DiscordBtnLink; as url) {
                <a [href]="url">
                  <img src="/assets/img/social/discord.svg" [alt]="seo.metaTitle" class="discord" />
                </a>
              }
              @if (social[0]?.TelegramBtnLink; as url) {
                <a [href]="url">
                  <img src="/assets/img/social/telegram.svg" [alt]="seo.metaTitle" class="telegram" />
                </a>
              }
              @if (social[0]?.TwitterBtnLink; as url) {
                <a [href]="url">
                  <img src="/assets/img/social/twitter.svg" [alt]="seo.metaTitle" class="twitter" />
                </a>
              }
              @if (social[0]?.InstagramBtnLink; as url) {
                <a [href]="url">
                  <img src="/assets/img/social/instagram.svg" [alt]="seo.metaTitle" class="instagram" />
                </a>
              }
            </div>
          </div>
        }
        <div class="license-block">
          <div class="license-block__logos">
            <div class="license-block__logos-item providers__item">
              <img ClassLoaded [attr.data-src]="'/assets/svg/security-logos/18.svg'" [alt]="seo.metaTitle" />
            </div>
            @if (license$ | async; as license) {
              @if (license.Url) {
                <a class="license-block__logos-item providers__item --curacao" target="_blank" rel="nonoopener" [href]="license?.Url">
                  <img ClassLoaded [attr.data-src]="license?.Img" alt="21bit casino - license">
                </a>
              } @else {
                <div class="license-block__logos-item providers__item --curacao">
                  <img ClassLoaded [attr.data-src]="license?.Img" alt="21bit casino - license">
                </div>
              }
            }
          </div>
          @if (copyright$ | async; as copyright) {
            <div class="copyright" [innerHTML]="copyright[0]?.Content | safe: 'html'"></div>
          }
        </div>
        <div class="providers --center align-center">
          <img
            class="providers__item"
            ClassLoaded
            alt="be-gamble-aware"
            [alt]="seo.metaTitle"
            [src]="'/assets/svg/security-logos/be-gamble-aware.svg'"
          />
          <img
            class="providers__item"
            ClassLoaded
            alt="comodossl"
            [alt]="seo.metaTitle"
            [src]="'/assets/svg/security-logos/comodossl.svg'"
          />
        </div>
        <ng-content></ng-content>
      </div>
    </footer>
  }
} @placeholder {
  <div></div>
}
